// src/data/colorInventory.js

export const COLOR_INVENTORY = [
  {
    id: "amethyst-orchid-purple-524",
    name: "Amethyst / Orchid Purple",
    code: "524",
    category: "purple",
    image: "amethyst-orchid-purple-524.png",
    widths: ['5/8"', '1.5"']
  },
  {
    id: "grape-pu527",
    name: "Grape Purple",
    code: "PU527",
    category: "purple",
    image: "grape-pu527.png",
    widths: ['for order']
  },
  {
    id: "purple-522",
    name: "Light Purple",
    code: "522",
    category: "purple",
    image: "purple-522.png",
    widths: ['5/8"']
  },
  {
    id: "violet-521",
    name: "Violet / Dark Purple",
    code: "521",
    category: "purple",
    image: "violet-521.png",
    widths: ['5/8"']
  },

  {
    id: "hot-pink-521",
    name: "Hot Pink",
    code: "521",
    category: "pink",
    image: "pink-521.png",
    widths: ['5/8"', '1.5"']
  },
  {
    id: "pink-523",
    name: "Medium Pink",
    code: "523",
    category: "pink",
    image: "pink-523.png",
    widths: ['for order']
  },
  {
    id: "pink-coral-524",
    name: "Pink Coral",
    code: "524",
    category: "pink",
    image: "pink-coral-524.png",
    widths: ['5/8"', '1"']
  },
  {
    id: "magenta-pink-526",
    name: "Magenta Pink",
    code: "526",
    category: "pink",
    image: "magenta-pink-526.png",
    widths: ['for order']
  },

  {
    id: "red-522",
    name: "Red",
    code: "522",
    category: "red",
    image: "red-522.png",
    widths: ['5/8"']
  },
  {
    id: "chili-red-523",
    name: "Chili Red",
    code: "523",
    category: "red",
    image: "chili-red-523.png",
    widths: ['for order']
  },
  {
    id: "wine-521",
    name: "Wine / Maroon",
    code: "521",
    category: "red",
    image: "wine-521.png",
    widths: ['5/8"']
  },

  {
    id: "bright-orange-522",
    name: "Bright Orange",
    code: "522",
    category: "orange",
    image: "orange-522.png",
    widths: ['5/8"', '1"']
  },
  {
    id: "orange-529",
    name: "Light Orange",
    code: "529",
    category: "orange",
    image: "orange-529.png",
    widths: ['for order']
  },

  {
    id: "yellow-521",
    name: "Yellow",
    code: "521",
    category: "yellow",
    image: "yellow-521.png",
    widths: ['5/8"']
  },
  {
    id: "yellow-527",
    name: "Bright / Neon Yellow",
    code: "527",
    category: "yellow",
    image: "yellow-527.png",
    widths: ['for order']
  },
  {
    id: "beta-gold-521",
    name: "Beta Gold",
    code: "521",
    category: "yellow",
    image: "beta-gold-521.png",
    widths: ['for order']
  },

  {
    id: "sagegreen-527",
    name: "Sage Green",
    code: "527",
    category: "green",
    image: "sagegreen-527.png",
    widths: ['5/8"', '1"']
  },
  {
    id: "olive-drab-521",
    name: "Olive Drab",
    code: "521",
    category: "green",
    image: "olive-drab-521.png",
    widths: ['for order']
  },
  {
    id: "green-522",
    name: "Forest Green",
    code: "522",
    category: "green",
    image: "green-522.png",
    widths: ['5/8"']
  },
  {
    id: "green-525",
    name: "Lime Green",
    code: "525",
    category: "green",
    image: "green-525.png",
    widths: ['5/8"']
  },
  {
    id: "green-528",
    name: "Bright Green",
    code: "528",
    category: "green",
    image: "green-528.png",
    widths: ['for order']
  },
  {
    id: "green-52k",
    name: "Mint Green",
    code: "52K",
    category: "green",
    image: "green-52k.png",
    widths: ['5/8"']
  },

  {
    id: "teal-521",
    name: "Teal",
    code: "521",
    category: "teal",
    image: "teal-521.png",
    widths: ['5/8"']
  },
  {
    id: "dusty-turquoise-tu521",
    name: "Dusty Turquoise",
    code: "TU521",
    category: "teal",
    image: "dusty-turquoise-tu521.png",
    widths: ['for order']
  },

  {
    id: "deep-sea-523",
    name: "Deep Sea Blue / Navy",
    code: "523",
    category: "blue",
    image: "deep-sea-523.png",
    widths: ['5/8"', '1"']
  },
  {
    id: "blue-522",
    name: "Royal Blue",
    code: "522",
    category: "blue",
    image: "blue-522.png",
    widths: ['5/8"']
  },
  {
    id: "blue-521",
    name: "Classic Blue",
    code: "521",
    category: "blue",
    image: "blue-521.png",
    widths: ['for order']
  },
  {
    id: "blue-52h",
    name: "Sky Blue",
    code: "52H",
    category: "blue",
    image: "blue-52h.png",
    widths: ['5/8"']
  },
  {
    id: "blue-52f",
    name: "Turquoise Blue",
    code: "52F",
    category: "blue",
    image: "blue-52f.png",
    widths: ['for order']
  },
  {
    id: "periwinkle-bu525",
    name: "Periwinkle Blue",
    code: "BU525",
    category: "blue",
    image: "periwinkle-bu525.png",
    widths: ['5/8"']
  },

  {
    id: "white-521",
    name: "White",
    code: "521",
    category: "neutral",
    image: "white-521.png",
    widths: ['5/8"', '1"']
  },
  {
    id: "grey-523",
    name: "Grey",
    code: "523",
    category: "neutral",
    image: "grey-523.png",
    widths: ['5/8"']
  },
  {
    id: "tan-525",
    name: "Tan",
    code: "525",
    category: "neutral",
    image: "tan-525.png",
    widths: ['for order']
  },
  {
    id: "brown-521",
    name: "Light Brown",
    code: "521",
    category: "brown",
    image: "brown-521.png",
    widths: ['5/8"']
  },
  {
    id: "brown-523",
    name: "Dark Brown",
    code: "523",
    category: "brown",
    image: "brown-523.png",
    widths: ['5/8"', '1"']
  },
  {
    id: "coyote-brown-521",
    name: "Coyote Brown",
    code: "521",
    category: "brown",
    image: "coyote-brown-521.png",
    widths: ['for order']
  },
  {
    id: "black-520",
    name: "Black",
    code: "520",
    category: "neutral",
    image: "black-520.png",
    widths: ['5/8"', '1"', '1.5"']
  }
];

export const getColorsByWidth = (width) => {
  return COLOR_INVENTORY.filter((color) => color.widths.includes(width));
};

export const getColorById = (id) => {
  return COLOR_INVENTORY.find((color) => color.id === id);
};